import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const professionalTitleValidator = yup.object().shape({
  type: yup.object().shape({
    id: yup.string().required(LOCALE.type + LOCALE.required_field),
  }),
  area: yup.object().shape({
    id: yup.string().required(LOCALE.role + LOCALE.required_field),
  }),
  proofs: yup.array().required(LOCALE.proof + LOCALE.required_field),
});

export const professionalTitlePointsValidator = yup.object().shape({
  points: yup.string().required(LOCALE.name + LOCALE.points),
  pointsChecked: yup.boolean().oneOf([true], "Must Approve Points"),
});
